import { css } from '../core'

/** Shared by `Tag` and `TagToggle`: base layout for a pill-shaped, icon+label control. */
export const tagPillBaseCss = css`
  align-items: center;
  display: inline-flex;
  font-weight: medium;
  justify-content: center;
  line-height: 1;
  position: relative;
  transition-duration: fast;
  width: fit-content;

  &:focus {
    outline: none;
  }
`
